import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Icon } from "antd";
import { setUnseenMessages, setUnReadCount } from "../redux/slices/chatSlice";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { useTheme } from "../utils/ThemeContext";
import { restrictedTrusteeTabs } from "./SidebarConstants";
const SidebarMenu = ({ item }) => {
  const { theme } = useTheme();
  const [subnav, setSubnav] = useState(false);
  const [white, setWhite] = useState();
  const [subwhite, setSubWhite] = useState();
  const dispatch = useDispatch();
  const unseenMessagesList = useSelector(
    (state) => state.rootReducer.chatInfo.unseenMessages
  );
  const unReadCount = useSelector(
    (state) => state.rootReducer.chatInfo.unReadCount
  );
  const location = useLocation();
  // const pathname = location;
  const showSubnav = () => {
    setSubnav(!subnav);
  };
  const duplicateUserRole =
    localStorage.getItem("duplicateRole") !== "undefined" &&
    JSON.parse(localStorage.getItem("duplicateRole"));
  const userRole =
    localStorage.getItem("role") !== "undefined" &&
    JSON.parse(localStorage.getItem("role"));

  const financialAccess =
    localStorage.getItem("financialAccess") != "undefined" &&
    JSON.parse(localStorage.getItem("financialAccess") || null);
  const restrictedClinetTabs = [
    "Chat",
    "Link Bank",
    "Manage Secure Links",
    "FAQ",
    "Feedback",
    ...(!financialAccess || !financialAccess.hideTransactions
      ? []
      : ["Reports"]),
  ];

  function hasPermission(checkPermissions = [], title) {
    const availablePermissions =
      localStorage.getItem("permissionState") != "undefined" &&
      JSON.parse(localStorage.getItem("permissionState") || null);
      const userRoles = ["Financial Advisor", "Active Financial Advisor"];
    if (
      (userRoles.includes(duplicateUserRole) ) &&
      restrictedClinetTabs.includes(title)
    ) {
      return false;
    }else if(["protrustee","trustee"].includes(userRole) && restrictedTrusteeTabs.includes(title)){
      return false;
    }
    return checkPermissions.some(
      (p) => availablePermissions && availablePermissions.includes(p)
    );
  }

  return (
    <>
      {location.pathname === "/profilePage" ? (
        <Link
          to={item.href}
          onClick={() => {
            item.subNav && showSubnav();
          }}
          style={{
            pointerEvents: hasPermission(item.permission, item.title)
              ? ""
              : "none",
          }}
        >
          <div
            className={
              location.pathname == item.href
                ? `side-menu-block1-active`
                : `side-menu-block1`
            }
            onMouseLeave={() => setWhite("")}
            onMouseOver={() => {
              setWhite("white");
            }}
          >
            <div
              style={{
                cursor: hasPermission(item.permission, item.title)
                  ? ""
                  : "not-allowed",
                pointerEvents: hasPermission(item.permission, item.title)
                  ? ""
                  : "none",
                opacity: hasPermission(item.permission, item.title)
                  ? "1"
                  : "0.5",
              }}
            >
              <img
                src={item.image}
                className={
                  white === "white" ||
                  item.href == location.pathname ||
                  theme === "dark"
                    ? "img-icon"
                    : "img-icon-dark"
                }
              />

              {/*  <img src={item.image} className="img-icon" /> */}
              <span
                style={{
                  paddingLeft: "10px",
                  color: theme === "dark" ? "white" : "",
                }}
                className=""
              >
                {item.title}
              </span>
            </div>
            {item.subNav && (
              <div className="">
                <Icon type="right" color={white} />
              </div>
            )}
          </div>
        </Link>
      ) : (
        <>
          {item.title === "FAQ Help Support" ? (
            <a href={item.href} target="blank">
              <div
                className={
                  location.pathname == item.href
                    ? `side-menu-block1-active`
                    : `side-menu-block1`
                }
                onMouseLeave={() => setWhite("")}
                onMouseOver={() => {
                  setWhite("white");
                }}
              >
                <div>
                  <img
                    src={item.whiteImage}
                    className={
                      white === "white" ||
                      item.href == location.pathname ||
                      theme === "dark"
                        ? "img-icon"
                        : "img-icon-dark"
                    }
                  />

                  <span
                    style={{
                      paddingLeft: "10px",
                      color: theme === "dark" ? "white" : "",
                    }}
                    className=""
                  >
                    {item.title}
                  </span>
                </div>
                {item.subNav && (
                  <div className="">
                    <Icon type="right" color={white} />
                  </div>
                )}
              </div>
            </a>
          ) : (
            <Link
              to={item.href}
              onClick={() => {
                item.subNav && showSubnav();
                if (item.title === "Chat") {
                  dispatch(setUnseenMessages([]));
                  dispatch(setUnReadCount(0));
                }
              }}
              style={{
                pointerEvents: hasPermission(item.permission, item.title)
                  ? ""
                  : "none",
              }}
            >
              <div
                className={
                  location.pathname == item.href
                    ? `side-menu-block1-active`
                    : `side-menu-block1`
                }
                onMouseLeave={() => setWhite("")}
                onMouseOver={() => {
                  setWhite("white");
                }}
              >
                <div
                  style={{
                    cursor: hasPermission(item.permission, item.title)
                      ? ""
                      : "not-allowed",
                    pointerEvents: hasPermission(item.permission, item.title)
                      ? ""
                      : "none",
                    opacity: hasPermission(item.permission, item.title)
                      ? "1"
                      : "0.5",
                  }}
                >
                  <img
                    src={item.whiteImage}
                    className={
                      white === "white" ||
                      item.href == location.pathname ||
                      theme === "dark"
                        ? "img-icon"
                        : "img-icon-dark"
                    }
                  />

                  {/*  <img src={item.image} className="img-icon" /> */}
                  <span
                    style={{
                      paddingLeft: "10px",
                      color: theme === "dark" ? "white" : "",
                    }}
                    className=""
                  >
                    {item.title}
                  </span>
                </div>
                {item.title === "Chat" &&
                  location.pathname !== "/chats" &&
                  ((unseenMessagesList &&
                    unseenMessagesList.filter((msg) => msg.status === "SENT")
                      .length > 0) ||
                    unReadCount > 0) && (
                    <div
                      className={
                        item.href == location.pathname
                          ? "chat-status-connectuser-message-sidebar-white"
                          : "chat-status-connectuser-message-sidebar"
                      }
                    >
                      {unReadCount +
                        unseenMessagesList.filter(
                          (msg) => msg.status === "SENT"
                        ).length || 0}
                    </div>
                  )}
                {item.subNav && (
                  <div className="">
                    <Icon type="right" color={white} />
                  </div>
                )}
              </div>
            </Link>
          )}
        </>
      )}
    </>
  );
};

export default SidebarMenu;
